import { jsx as i } from "react/jsx-runtime";
import n from "./index.es734.js";
import { PrimitiveSimilarityBar as p } from "./index.es143.js";
import { CellAdditionalInfoWrapper as d } from "./index.es731.js";
const y = ({
  testId: r,
  levelValue: t,
  additionalValue: l,
  formatValue: o,
  levelValuePosition: e,
  thresholds: m,
  additionalInfo: a
}) => /* @__PURE__ */ i("div", { "data-testid": `${r}-cell`, className: n.root, children: /* @__PURE__ */ i(d, { ...a, children: /* @__PURE__ */ i(
  p,
  {
    testId: r,
    isWithinDataCell: !0,
    levelValue: t,
    additionalValue: l,
    formatValue: o,
    levelValuePosition: e,
    thresholds: m
  }
) }) });
export {
  y as SimilarityCell
};
//# sourceMappingURL=index.es560.js.map
